import { render, staticRenderFns } from "./DndMultiSelect.vue?vue&type=template&id=4ed06b56&"
import script from "./DndMultiSelect.vue?vue&type=script&lang=js&"
export * from "./DndMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports